import { render } from "./ProductShare.vue?vue&type=template&id=f3b7a26a"
import script from "./ProductShare.vue?vue&type=script&lang=js"
export * from "./ProductShare.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafepayam-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__